/**
 * AnswerBlank - A styled placeholder for where students should enter their answer
 *
 * Displays a "?" inside a bordered box to clearly indicate the answer field.
 */

import React from 'react';

const AnswerBlank: React.FC = () => {
  return (
    <span className="inline-flex items-center justify-center border-[1.5px] border-gray-800 px-3 py-0.5 rounded-md mx-1">
      ?
    </span>
  );
};

export default AnswerBlank;
